import * as React from 'react';
import { t } from '@moovly/i18n';
import { FontSettings } from '@moovly/clients/lib/resources/settings/settings.interfaces';
import { Select } from '@moovly/ui';
import { SettingsPanel, useSettingUpdate } from '@moovly/moovly-settings';

const getNoTextStyle = () => ({
  value: 'null',
  label: t('settings.text.noTextStyle'),
});
const EditorTextSettings: React.FC = () => {
  const { value: fontSettings, onUpdate } = useSettingUpdate<FontSettings>('font');
  const textStyleSelection = React.useMemo<{ value: string; label: string }[]>(() => {
    return !!fontSettings
      ? [
          getNoTextStyle(),
          ...fontSettings.text_styles!.map((style) => ({
            value: style.identifier,
            label: style.label,
          })),
        ]
      : [getNoTextStyle()];
  }, [fontSettings]);

  const handleDefaultTextStyleChange = React.useCallback(
    (prop: 'default_text_style' | 'default_subtitle_text_style') =>
      ({ value }: any) => {
        onUpdate({ ...fontSettings, [prop]: value });
      },
    [fontSettings, onUpdate]
  );
  if (!fontSettings) {
    return null;
  }
  return (
    <SettingsPanel title={t('settings.text.title')}>
      {t('settings.text.defaultTextStyle')}
      <Select
        options={textStyleSelection}
        onChange={handleDefaultTextStyleChange('default_text_style')}
        value={textStyleSelection.find((s) => s.value === fontSettings.default_text_style)}
      />
      {t('settings.text.defaultSubtitleStyle')}
      <Select
        options={textStyleSelection}
        onChange={handleDefaultTextStyleChange('default_subtitle_text_style')}
        value={textStyleSelection.find((s) => s.value === fontSettings.default_subtitle_text_style)}
      />
    </SettingsPanel>
  );
};
export default EditorTextSettings;
